import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Icon } from '~/components'
import timestamps from '~/services/timestamps'

import { flareComment } from '~/actions/article'

import { CommentReply } from './'

class Comment extends React.Component {
    static propTypes = {
		articleID: PropTypes.number,
		date: PropTypes.string.isRequired,
		isSession: PropTypes.bool.isRequired,
		ID: PropTypes.number.isRequired,
		parent: PropTypes.number.isRequired,
		replyID: PropTypes.number,
		title: PropTypes.string.isRequired,
	};

    state = {
        reply: false
    };

    toggleReply = () => {
		this.setState({
			reply: !this.state.reply
		})
	};

    flare = () => {
		this.props.flareComment(this.props.ID)
	};

    render() {
		return (
			<div className={"comment bg-white p10 " + ('children' in this.props ? this.props.children.length > 0 && 'has-children' : 'child')}>
				<div className="comment-profile-image-wrapper">
					<Link to={this.props.user.link}>
						<div className="profile-image" style={{backgroundImage: 'url(' + this.props.user.profile_picture + ')'}} />
					</Link>
		    		<p className="text-center mtop10">
		    			<Icon icon={'flares'} className={this.props.flared ? 'text-mid-danger' : 'text-dark-gray'} onClick={this.flare} />
		    			{this.props.flares.length} 
	    			</p>
					<div className="clearfix" />
				</div>
				<div className="content-wrapper">
					<h5 className="mtop0 mbot10">{this.props.user.first + ' ' + this.props.user.last}</h5>
					<p className="small mbot15"><em>{timestamps.timeSince(this.props.date)}</em></p>
					<p className="" dangerouslySetInnerHTML={{ __html: this.props.title.replace(/(?:\r\n|\r|\n)/g, '<br />') }} />
					{ this.state.reply 
						? <CommentReply articleID={this.props.articleID} closeReply={this.toggleReply} replyID={!!this.props.replyID ? this.props.replyID : false} />
	    				: this.props.isSession && <p className="pull-right clickable small mtop10" onClick={this.toggleReply}>Reply</p>
					}
				</div>
				<div className="clearfix" />
        	</div>
		)
	}
}

const mapStateToProps = state => ({
    user: state.session.user,
});

const mapDispatchToProps = dispatch => bindActionCreators({ flareComment }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Comment);




// WEBPACK FOOTER //
// ./src/js/views/Article/components/Comments/components/SingleComment.js